import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    candidateBoards: {
      selectIds: [],
      filters: {},
      stagesInfo: {}
    }
  },
  mutations: {
    RESET_CANDIDATEBOARD (store) {
      store.candidateBoards.selectIds = []
      store.candidateBoards.filters = {}
      store.candidateBoards.stagesInfo = {}
    },
    ADDEND_CANDIDATEBOARD_SELECT_IDS (store, ids) {
      const c = store.candidateBoards.selectIds.concat(ids)
      const d = c.filter((item, pos) => c.indexOf(item) === pos)
      store.candidateBoards.selectIds = d
    },
    ADDINIT_CANDIDATEBOARD_SELECT_IDS (store, ids) {
      const c = ids.concat(store.candidateBoards.selectIds)
      const d = c.filter((item, pos) => c.indexOf(item) === pos)
      store.candidateBoards.selectIds = d
    },
    ADD_CANDIDATEBOARD_STAGES_INFO (store, stageInfo) {
      store.candidateBoards.stagesInfo = {
        ...store.candidateBoards.stagesInfo,
        ...{[stageInfo.stage_id]: stageInfo}
      }
    },
    SET_CANDIDATEBOARD_FILTERS (store, filters) {
      store.candidateBoards.filters = filters
    },
    REMOVE_CANDIDATEBOARD_SELECT_IDS (store, ids) {
      store.candidateBoards.selectIds = store.candidateBoards.selectIds.filter((v) => { return !ids.includes(v) })
    }
  },
  getters: {
    getCandidateBoards: (store, getters) => {
      const {
        job_id: jobId
        // status
      } = store.candidateBoards.filters

      return store.candidateBoards.selectIds.map((id) => {
        return getters['entities/candidates/query']().find(id)
      }).map(candidate => {
        return {
          ...candidate,
          placement: candidate.placements.find(placement => placement.job_id === jobId) // && placement.status === status
        }
      }).filter(candidate => {
        return candidate.placement
      }).sort((doc1, doc2) => {
        return new Date(doc2.placement.stage_date).getTime() - new Date(doc1.placement.stage_date).getTime()
      })
    },
    getCandidateBoardsFilters: (store, getters) => {
      return store.candidateBoards.filters
    },
    getCandidateBoardsStages: (store, getters) => {
      return store.candidateBoards.stagesInfo
    }
  },
  actions: {
    /*
    selectCandidateBoard
    */
    selectCandidateBoard ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/candidates/board-start`, {params: filters})
      .then((response) => {
        commit('RESET_CANDIDATEBOARD')
        commit('SET_CANDIDATEBOARD_FILTERS', filters)

        return Promise.all(response.data.map(item => {
          return dispatch('entities/candidates/insertOrUpdate', {
            data: item.docs
          })
          .then((result) => {
            commit('ADDEND_CANDIDATEBOARD_SELECT_IDS', item.docs.map(v => v._id))
            commit('ADD_CANDIDATEBOARD_STAGES_INFO', {stage_id: item.stage_id, has_more: item.has_more})

            return {
              ...item,
              docs: getters['entities/candidates/findIn'](item.docs.map(v => v._id)) // insertOrUpdate traz o resultado ordenado
            }
          })
        }))
      })
    },
    /*
    refreshSelectCandidateBoard
    */
    refreshSelectCandidateBoard ({commit, dispatch, getters, state}) {
      return dispatch('selectCandidateBoard', getters.getCandidateBoardsFilters)
    },
    /*
    selectCandidateStageBoard
    */
    selectCandidateStageBoard ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/candidates/board-stage`, {params: filters})
      .then((response) => {
        return dispatch('entities/candidates/insertOrUpdate', {
          data: response.data.docs
        })
        .then((result) => {
          commit('ADDEND_CANDIDATEBOARD_SELECT_IDS', response.data.docs.map(v => v._id))
          commit('ADD_CANDIDATEBOARD_STAGES_INFO', {stage_id: response.data.stage_id, has_more: response.data.has_more})

          return {
            ...response.data,
            docs: getters['entities/candidates/findIn'](response.data.docs.map(v => v._id)) // insertOrUpdate traz o resultado ordenado
          }
        })
      })
    },
    /*
    socketCandidateStageBoard
    */
    socketCandidateStageBoard ({commit, dispatch, getters, state}, message) {
      const {
        method,
        _id,
        jobId
      } = message

      const ids = state.candidateBoards.selectIds
      if (method === 'update' && ids.includes(_id)) {
        dispatch('getCandidateById', _id)
      }
      if (method === 'create' && getters.getJob && getters.getJob._id === jobId) {
        dispatch('getCandidateById', _id).then(res => {
          commit('ADDINIT_CANDIDATEBOARD_SELECT_IDS', [res._id])
        })
      }
      if (method === 'delete' && ids.includes(_id)) {
        commit('REMOVE_CANDIDATEBOARD_SELECT_IDS', [_id])
        dispatch('entities/candidates/delete', _id)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/CandidateBoard.js